import { Skeleton } from "@mui/material";

export default function SkeletonUi() {
  return <Skeleton variant="rectangular" width="100%" height="100%" />;
}
